import { useEffect, useState, FunctionComponent, MouseEvent } from 'react'
import getUrl from 'libraries/front-end-core/core/url'
import { QA_CONTENT, QA_MENU } from 'constants/controllers'
import { Flavour } from 'types/Flavour'
import Breadcrumbs, { Crumb } from 'components/Breadcrumbs'
import { AOL_DISPLAY_NAMES } from 'constants/aol/aol'
import FlavourIcon from 'components/shared/FlavourIcon'
import { FLAVOUR_TITLES } from 'constants/flavours'

const category = 'Q&A'

const action = 'Breadcrumb'

const Title: FunctionComponent<TitleProps> = ({
  section,
  aol,
  flavour,
  expandedNodeTitle,
  sectionId,
  sectionsMap,
  handleExpandedTitleOnClick,
  isProxy = false
}) => {
  const [sectionTitle, setSectionTitle] = useState(section)
  const sectionUrl = getUrl(QA_CONTENT, { flavour, sectionId, aol })

  // history is not really working right around qa and its probably related to this
  const handleSectionBreadcrumbOnClick = (e: MouseEvent): void => {
    handleExpandedTitleOnClick(e)
    const sectionUrl = getUrl(QA_CONTENT, { flavour, sectionId, aol })
    history.pushState({}, '', sectionUrl)
  }

  useEffect(() => {
    if (isProxy && sectionId !== '' && sectionsMap !== null && sectionsMap.has(sectionId)) {
      const qaSection = sectionsMap.get(sectionId)
      if (qaSection !== undefined) setSectionTitle(qaSection.title)
    }
  }, [isProxy, section, setSectionTitle, sectionId, sectionsMap])

  const crumbs: Crumb[] = [
    {
      label: 'Q&A',
      href: getUrl(QA_MENU, { aol, flavour }),
      analytics: { category, action, label: category, aol }
    },
    {
      label: AOL_DISPLAY_NAMES[aol as keyof typeof AOL_DISPLAY_NAMES],
      href: `${getUrl(QA_MENU, { aol, flavour })}#${aol}`,
      analytics: { category, action, aol, label: AOL_DISPLAY_NAMES[aol as keyof typeof AOL_DISPLAY_NAMES] }
    }
  ]

  const hasExpandedNodeTitle = expandedNodeTitle !== null && expandedNodeTitle !== ''

  if (hasExpandedNodeTitle) {
    crumbs.push({
      label: sectionTitle,
      href: sectionUrl,
      onClickOverride: handleSectionBreadcrumbOnClick,
      analytics: { category, action, aol, label: sectionTitle }
    })
  }

  return (
    <div className='w-100 bg-page-background'>
      <div className='pv6 layout-width-constraint flex justify-between items-center'>
        <Breadcrumbs
          crumbs={crumbs}
          current={hasExpandedNodeTitle ? expandedNodeTitle : sectionTitle}
          icon='qa'
        />
        <div className='flex justify-center items-center ba br2 b--dark-cerulean pa2'>
          <FlavourIcon flavour={flavour} />
          <span className='ml2 dn-m'>
            {FLAVOUR_TITLES[flavour]}
          </span>
        </div>
      </div>
    </div>
  )
}

interface TitleProps {
  section: string
  aol: string
  flavour: Flavour
  expandedNodeTitle: string
  sectionId: string
  sectionsMap: Map<string, { title: string }> | null
  handleExpandedTitleOnClick: (event: MouseEvent) => void
  isProxy: boolean
}

export default Title
